import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import { SmoothScroll } from "./components/SmoothScroll";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CookieBanner } from "./components/CookieBanner";
import Home from "./pages/Home";
import Rooms from "./pages/Rooms";
import Amenities from "./pages/Amenities";
import About from "./pages/About";
import Location from "./pages/Location";
import GalleryPage from "./pages/GalleryPage";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <SmoothScroll />
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-charcoal focus:px-4 focus:py-2 focus:text-cream">Zum Inhalt springen</a>
        <Header />
        <div id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/zimmer" element={<Rooms />} />
            <Route path="/ausstattung" element={<Amenities />} />
            <Route path="/ueber-uns" element={<About />} />
            <Route path="/lage" element={<Location />} />
            <Route path="/galerie" element={<GalleryPage />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
        <CookieBanner />
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </LanguageProvider>
  );
}
